
import React from 'react';
import { Input } from '@/components/ui/input';

interface ChatLogsFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export function ChatLogsFilter({ value, onChange }: ChatLogsFilterProps) {
  return (
    <Input
      placeholder="Search chat logs by message content..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full"
    />
  );
}
